import React from 'react';
import '../styles/AboutPreview.css'; // We’ll add simple CSS too

function AboutPreview() {
  return (
    <section className="about-preview">
      <div className="container">
        <h2>About Bularis Tech</h2>
        <p>
          At Bularis Tech, we build custom Shopify stores, powerful web applications,
          and deliver creative digital solutions that help brands grow globally.
        </p>
        <a href="/about" className="btn-primary">Learn More</a>
      </div>
    </section>
  );
}

export default AboutPreview;